import { useTokens } from "@/domains/api/hooks/use-tokens"
import { isAddressEqual } from "viem"

import { useApiService } from "./use-api-service"
import { useGovernanceToken } from "./use-governance-token"

export const useGovernanceTokenPrice = () => {
  const apiService = useApiService()
  const governanceToken = useGovernanceToken()
  const { tokens } = useTokens({ apiService, refreshInterval: 1000 * 300 })

  const found = tokens.find((token) => isAddressEqual(token.address, governanceToken?.address))

  return Number(found?.priceUsd ?? 0)
}
